// Enum which will contain all native method which needs to calling from JS
const NATIVEFUNCTION_TYPE = {
  closeWebView: 'closeWebView',
  openDialer: 'openDialer',
  getBeatClosureData: 'getBeatClosureData',
  callToP4B: 'callToP4B',
  openCamera: 'openCamera',
  openFrontCamera: 'openFrontCamera',
  deleteImage: 'deleteImage',
  shouldHeaderVisible: 'shouldHeaderVisible',
  isNetworkAvailable: 'isNetworkAvailable',
  sendEventsToHawkeye: 'sendEventsToHawkeye',
  getCurrentLocation: 'getCurrentLocation',
  getCurrentLocationWithAccuracy: 'getCurrentLocationWithAccuracy',
  getAuthData: 'getAuthData',
  logout: 'logout',
  openDeepLink: 'openDeepLink',
  openExternalApp: 'openExternalApp',
  openCalendarExternalApp: 'openCalendarExternalApp',
  hasPermission: 'hasPermission',
  analyticsEvent: 'analyticsEvent',
  disableScreenshot: 'disableScreenshot',
  manageUser: 'manageUser',
  getUserRole: 'getUserRole',
  pushHawkeyeEvent: 'pushHawkeyeEvent',
  deleteEvent: 'deleteEvent',
  saveEventToCalendar: 'saveEventToCalendar',
  updateEvent: 'updateEvent',
  getAppVersion: 'getAppVersion',
  updateWidget: 'updateWidget',
  openShareDialog: 'openShareDialog',
  showQuestionsScreen: 'showQuestionsScreen',
  launchUniversalAddressComponent: 'launchUniversalAddressComponent',
  getCryptoVersionKey: 'getCryptoVersionKey',
  launchATSInventoryPage: 'launchATSInventoryPage',
};

export default NATIVEFUNCTION_TYPE;
